import { render, staticRenderFns } from "./bSidebar.vue?vue&type=template&id=48adf972&"
import script from "./bSidebar.vue?vue&type=script&lang=ts&"
export * from "./bSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports